// The `admin` query param / persistence field is numeric: 0 client, 1 admin,
// 2 warehouseman, 3 back-office, 4 partner. UI works with the slugs.
const ROLE_TO_PERSISTENCE: Record<string, string> = {
  client: '0',
  admin: '1',
  warehouseman: '2',
  'back-office': '3',
  partner: '4',
};

export const getPersistenceUserRole = (role?: string | null): string | undefined => (role ? ROLE_TO_PERSISTENCE[role] : undefined);

export const getUserRole = (value?: string | number | null): string | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  return Object.keys(ROLE_TO_PERSISTENCE).find((role) => ROLE_TO_PERSISTENCE[role] === String(value));
};
